















































































import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import { newVirtualMachineService } from '@/components/new-virtual-machine/services/NewVirtualMachineService';
import { SshKey } from '@/interfaces/SshKey';
import { NewVirtualMachineData } from '@/interfaces/NewVirtualMachineData';
import md5 from 'crypto-js/md5';
import * as sshpk from 'sshpk';

@Component({
  props: ['keys'],
})
export default class KeysConfigurationDialog extends Vue {
  serverKeys: SshKey[] = [];
  selectedKeys: SshKey[] = [];
  newAdditionalKeyId = 0;
  newKeyData = '';
  scrollTopCSS = '';
  workspaceId = 0;
  regionId = 0;
  originalSelectedKeys: SshKey[] = [];
  isActiveSSHKeyValidation = false;
  doesSSHKeyAlreadyExist = false;
  noKeysSelected = false;

  getFingerprint(key: string) {
    let parsedKey = null;
    try {
      parsedKey = sshpk.parseKey(key, 'auto');
    } catch (e) {
      return '-';
    }
    return parsedKey ? parsedKey.fingerprint('md5').toString() : '-';
  }

  testKey(key: string) {
    let parsedKey = null;
    try {
      parsedKey = sshpk.parseKey(key, 'auto');
    } catch (e) {
      return false;
    }
    return !!(parsedKey && parsedKey.type);
  }

  mounted() {
    this.scrollTopCSS = `top: ${window.scrollY}px;`;
    this.selectedKeys = this.$props.keys;
    this.originalSelectedKeys = JSON.parse(JSON.stringify(this.$props.keys));
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    newVirtualMachineService
      .getNewVirtualMachineData(this.workspaceId, this.regionId)
      .then((data: NewVirtualMachineData) => {
        this.serverKeys = data.ssh_keys.filter((item: SshKey) => {
          return !this.findKeys(this.selectedKeys, item).length;
        });
        this.serverKeys = this.serverKeys.filter(
          (elem, index) => this.serverKeys.findIndex(obj => obj.fingerprint === elem.fingerprint) === index
        );
      });
  }

  @Watch('selectedKeys', { immediate: true, deep: true })
  onKeysChanged() {
    this.onKeys(this.selectedKeys);
  }

  isSSHKeyAlreadyInUse() {
    const trimmedKey = this.newKeyData.trim();
    const sameKey = this.selectedKeys.filter((item: any) => item.public_key === trimmedKey);
    const fingerprint = this.getFingerprint(trimmedKey);
    const serverKey = this.serverKeys.filter((item: any) => item.fingerprint === fingerprint);
    this.doesSSHKeyAlreadyExist = sameKey.length !== 0 || serverKey.length !== 0;
  }

  addKey(key: SshKey) {
    this.selectedKeys = this.filterKeys(this.selectedKeys, key);
    this.selectedKeys.push(key);
    this.serverKeys = this.filterKeys(this.serverKeys, key);
    this.isSSHKeyAlreadyInUse();
  }

  removeKey(key: SshKey) {
    this.selectedKeys = this.filterKeys(this.selectedKeys, key);
    this.serverKeys = this.filterKeys(this.serverKeys, key);
    this.serverKeys.push(key);
    this.isSSHKeyAlreadyInUse();
  }

  addNewKey() {
    this.isActiveSSHKeyValidation = true;
    if (!this.newKeyData) {
      return;
    }
    this.newKeyData = this.newKeyData.trim();
    if (!this.testKey(this.newKeyData)) {
      return;
    }

    const sameKey = this.selectedKeys.filter((item: any) => item.public_key === this.newKeyData);
    const fingerprint = this.getFingerprint(this.newKeyData);
    const serverKey = this.serverKeys.filter((item: any) => item.fingerprint === fingerprint);
    if (sameKey.length !== 0 || serverKey.length !== 0) {
      this.doesSSHKeyAlreadyExist = true;
      return;
    }

    this.newAdditionalKeyId += 1;
    let isIdDuplicated = true;
    while (isIdDuplicated) {
      if (!this.selectedKeys.find(item => item.name === `${this.$t('keysConf.newKey')} ${this.newAdditionalKeyId}`)) {
        isIdDuplicated = false;
      } else {
        this.newAdditionalKeyId += 1;
      }
    }
    this.selectedKeys.push({
      id: null,
      name: `${this.$t('keysConf.newKey')} ${this.newAdditionalKeyId}`,
      fingerprint: this.getFingerprint(this.newKeyData),
      public_key: this.newKeyData,
    });
    this.newKeyData = '';
    this.isActiveSSHKeyValidation = false;
  }

  onCancel() {
    this.isActiveSSHKeyValidation = false;
    this.selectedKeys = this.originalSelectedKeys;
    this.onClose();
    if (this.selectedKeys.length === 0) {
      this.onEmptyKeys();
    }
  }

  @Emit()
  saveSSHKeys() {
    if (this.selectedKeys.length) {
      this.onClose();
    } else {
      this.noKeysSelected = true;
    }
  }

  @Emit()
  onClose() {
    this.onKeys(this.selectedKeys);
    return;
  }

  @Emit()
  onEmptyKeys() {
    return true;
  }

  @Emit()
  onKeys(keys: any) {
    return keys;
  }

  private filterKeys(keys: SshKey[], match: SshKey) {
    return keys.filter((item: SshKey) => item.fingerprint !== match.fingerprint);
  }

  private findKeys(keys: SshKey[], match: SshKey) {
    return keys.filter((item: SshKey) => JSON.stringify(item) === JSON.stringify(match));
  }
}
